import { Injectable } from '@angular/core';
import { Api } from '..';

export class Produto {
    public idProduto: number;
    public produto: string;
    public nomeReduzido: string;
    public unidade: string;
    public referencia: string;
    public codAux: string;
    public precoVenda: number;
    public precoSugerido: number;
    public observacoes: string;
    public descricaoAux: string;

    constructor() {
      this.idProduto = 0;
      this.produto = '';
      this.nomeReduzido = '';
      this.unidade = '';
      this.referencia = '';
      this.codAux = '';
      this.precoVenda = 0;
      this.precoSugerido = 0;
      this.observacoes = '';
      this.descricaoAux = '';
    }
}
@Injectable()
export class ProdutoProvider {
  constructor(public api: Api) {}

  gets(pagination) {
    return this.api.gets('produto/gets', pagination);
  }

  get(idCliente) {
    return this.api.get('produto/get', idCliente);
  }
}



// WEBPACK FOOTER //
// ./src/providers/produto/produto.ts